import * as yup from "yup";

const updateReportRequestValidator = yup
  .object({
    declined_reason: yup.string().required("Declined Reason is required"),
    status: yup.string().required("Status is required").default("declined"),
  })
  .required();

export default updateReportRequestValidator;
